export default __webpack_public_path__ + "static/Chileshiddenkingdomoffungi-80975c254d5a1bf7da3bea7ef58f4db9.jpg";